<ng-container
  *ngIf="employment || isNewEmployment"
  [formGroup]="form">
  <div
    class="card-box compressed-main-info"
    *ngIf="showCompressedEmploymentInfo && employment">
    <app-employment-canceled-info
      *ngIf="employment.status === EmploymentStatusEnum.CANCELED"
      [employment]="employment"></app-employment-canceled-info>
    <div class="header-meta">
      <app-employment-date [employment]="employment"></app-employment-date>
      <app-employment-counts [employment]="employment"></app-employment-counts>
    </div>
    <app-employment-organisation-heading
      class="employment-heading"
      [employment]="employment"></app-employment-organisation-heading>
    <app-dispo-employment-details-table
      [employment]="employment"></app-dispo-employment-details-table>
    <div
      class="compressed-view-actions"
      *ngIf="!formDisabled && hasEditPermission">
      <button
        class="outline-pill-button icon-left"
        type="button"
        (click)="showCompressedEmploymentInfo = false"
        data-cy="edit-employment-button">
        <mat-icon svgIcon="pencil-outline"></mat-icon>
        <span class="mat-fab__label">{{
          ("edit" | i18n) || "bearbeiten" | titlecase
        }}</span>
      </button>
    </div>
  </div>
  <ng-container
    *ngIf="
      employment?.status === employmentStatusEnum.OPEN &&
      loggedInCustomer?._id !== employment?.customer?.id
    ">
    <div class="card-box card-box__small">
      <div class="form-row-md-2-cols">
        <app-user-select
          class="light-form-field"
          name="editor"
          [label]="('editor' | i18n) || 'Bearbeiter:in' | titlecase"
          [formControl]="editorIdControl"
          [filterRole]="roleEnum.DISPO"></app-user-select>
      </div>
    </div>
  </ng-container>
  <div
    class="card-box"
    *ngIf="!showCompressedEmploymentInfo">
    <app-user-select
      class="light-form-field"
      [label]="('editor' | i18n) || 'Bearbeiter:in' | titlecase"
      [formControl]="editorIdControl"
      [filterRole]="roleEnum.DISPO"></app-user-select>
  </div>
  <div
    class="card-box"
    *ngIf="!showCompressedEmploymentInfo">
    <h1 class="card-title">
      {{ ("employment" | i18n) || "Einsatz" | titlecase }}
    </h1>
    <app-department-select
      class="light-form-field"
      [label]="
        ('organisationAndDepartment' | i18n) || 'Organisation, Abteilung'
          | titlecase
      "
      (departmentSelectionChanged)="selectDepartment($event)"
      [selectedDepartmentId]="selectedDepartmentIdControl.value"
      [valid]="selectedDepartmentIdControl.valid"
      [autoSelectOnlyDepartment]="true"
      [disabled]="selectedDepartmentIdControl.disabled"
      [required]="true"></app-department-select>
    <h2 class="form-group-label">
      {{ ("timespan" | i18n) || "Zeitraum" | titlecase }}
    </h2>
    <div class="dates-row">
      <mat-form-field
        class="light-form-field"
        [class.mat-form-field-invalid]="
          !startDateControl.valid && startDateControl.touched
        ">
        <mat-label>
          {{ ("from" | i18n) || "Von" | titlecase }}
        </mat-label>
        <input
          matInput
          [value]="startDateControl.value | date"
          readonly
          (click)="datePickerFrom.open()"
          required
          [disabled]="startDateControl.disabled"
          data-cy="datepicker-from" />
        <input
          matInput
          required
          name="datepicker"
          (dateChange)="selectStartDate($event)"
          (click)="datePickerFrom.open()"
          [matDatepicker]="datePickerFrom"
          [formControl]="startDateControl"
          [class.warning]="false"
          hidden />
        <mat-datepicker-toggle
          matSuffix
          [for]="datePickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #datePickerFrom></mat-datepicker>
        <mat-hint *ngIf="employment?.initialStartDate">
          {{
            ("initialStartDate" | i18n) || "Ursprüngliches Startdatum"
              | titlecase
          }}: {{ employment?.initialStartDate | date }}
        </mat-hint>
      </mat-form-field>
      <mat-form-field
        class="light-form-field"
        [class.mat-form-field-invalid]="
          !endDateControl.valid && endDateControl.touched
        ">
        <mat-label>
          {{ ("to" | i18n) || "Bis" | titlecase }}
        </mat-label>
        <input
          matInput
          [value]="endDateControl.value | date"
          readonly
          (click)="datePickerTo.open()"
          required
          [disabled]="endDateControl.disabled"
          data-cy="datepicker-to" />
        <input
          matInput
          required
          name="datepicker"
          (dateChange)="selectEndDate($event)"
          (click)="datePickerTo.open()"
          [matDatepicker]="datePickerTo"
          [formControl]="endDateControl"
          [class.warning]="false"
          [min]="startDateControl.value"
          hidden />
        <mat-datepicker-toggle
          matSuffix
          [for]="datePickerTo"></mat-datepicker-toggle>
        <mat-datepicker #datePickerTo></mat-datepicker>
        <mat-hint *ngIf="employment?.initialEndDate">
          {{
            ("initialEndDate" | i18n) || "Ursprüngliches Enddatum" | titlecase
          }}:
          {{ employment?.initialEndDate | date }}
        </mat-hint>
      </mat-form-field>
      <mat-form-field
        class="light-form-field"
        [class.mat-form-field-invalid]="
          !endDateControl.valid && endDateControl.touched
        ">
        <mat-label>
          {{ ("workloadInPercent" | i18n) || "Pensum in %" | titlecase }}
        </mat-label>
        <input
          matInput
          [formControl]="workloadControl"
          type="number"
          min="0"
          max="100"
          required
          data-cy="workload-input" />
        <mat-hint *ngIf="employment?.initialWorkload">
          {{
            ("initialWorkload" | i18n) || "Ursprüngliches Pensum" | titlecase
          }}: {{ employment?.initialWorkload }}%
        </mat-hint>
      </mat-form-field>
    </div>

    <mat-form-field class="light-form-field">
      <mat-label>{{
        ("description" | i18n) || "description" | titlecase
      }}</mat-label>
      <textarea
        matInput
        [placeholder]="('description' | i18n) || 'description' | titlecase"
        [formControl]="descriptionControl"
        name="description"
        rows="7"
        data-cy="description-input">
      </textarea>
    </mat-form-field>
  </div>
  <!--TODO: (select hidden with class) add the Vermittler select back in or completely remove it when we decided on the "vermittler" behavior after MVP -->
  <div class="card-box hidden">
    <h1 class="card-title">
      {{ ("agency" | i18n) || "Vermittler" | titlecase }}
    </h1>
    <div class="row">
      <div class="col-md-6">
        <app-customer-multi-select
          class="light-form-field"></app-customer-multi-select>
      </div>
    </div>
  </div>
  <div class="card-box">
    <h1 class="card-title">
      {{ ("criteria" | i18n) || "Kriterien" | titlecase }}
    </h1>
    <div class="form-row-md-2-cols">
      <app-sex-select
        [formControl]="sexControl"
        class="light-form-field"
        *ngIf="!loggedInCustomer?.hiddenFields?.employmentSex">
        <ng-template
          #hint
          *ngIf="hasDeviatingSex$ | async">
          <div
            class="input-hint"
            data-cy="original-sex-hint">
            {{ ("originally" | i18n) || "Ursprünglich" | titlecase }}:
            <span *ngIf="(deviatingSexValue$ | async) === sexEnum.FEMALE">
              {{ ("femaleSex" | i18n) || "female" | titlecase }}
            </span>
            <span *ngIf="(deviatingSexValue$ | async) === sexEnum.MALE">
              {{ ("maleSex" | i18n) || "male" | titlecase }}
            </span>
            <span
              *ngIf="
                (deviatingSexValue$ | async) === undefined ||
                (deviatingSexValue$ | async) === null
              ">
              {{ ("empty" | i18n) || "nicht definiert" | titlecase }}
            </span>
          </div>
        </ng-template>
      </app-sex-select>
      <div></div>
      <app-certificate-select
        *ngIf="!loggedInCustomer?.hiddenFields?.employmentCertificates"
        class="light-form-field"
        [disabled]="certificatesControl.disabled"
        [required]="
          loggedInCustomer?.requiredEmploymentFields?.certificates || false
        "
        [showHint]="(hasDeviatingCertificates$ | async)!"
        [doNotUpdateRecentlyUsed]="true"
        [selectedMappedCertificates]="certificatesControl.value"
        (selectionChanged)="certificatesSelected($event)">
        <ng-container
          slot="hint"
          *ngIf="hasDeviatingCertificates$ | async">
          <div
            class="input-hint"
            [attr.title]="deviatingCertificatesValue$ | async"
            data-cy="original-certificates-hint">
            {{ ("originally" | i18n) || "Ursprünglich" | titlecase }}:
            <span>
              {{ deviatingCertificatesValue$ | async }}
            </span>
          </div>
        </ng-container>
      </app-certificate-select>
      <app-speciality-select
        *ngIf="!loggedInCustomer?.hiddenFields?.employmentSpecialities"
        class="light-form-field"
        [disabled]="specialitiesControl.disabled"
        [showHint]="(hasDeviatingSpecialities$ | async)!"
        [doNotUpdateRecentlyUsed]="true"
        [selectedMappedSpecialities]="specialitiesControl.value"
        (selectionChanged)="specialitiesSelected($event)">
        <ng-container
          slot="hint"
          *ngIf="hasDeviatingSpecialities$ | async">
          <div
            class="input-hint"
            [attr.title]="deviatingSpecialitiesValue$ | async"
            data-cy="original-specialities-hint">
            {{ ("originally" | i18n) || "Ursprünglich" | titlecase }}:
            <span>
              {{ deviatingSpecialitiesValue$ | async }}
            </span>
          </div>
        </ng-container>
      </app-speciality-select>
      <app-mobility-select
        *ngIf="!loggedInCustomer?.hiddenFields?.employmentMobility"
        class="light-form-field"
        data-cy="employment-mobility-select"
        [formControl]="carControl">
        <ng-template
          #hint
          *ngIf="hasDeviatingCar$ | async">
          <div
            class="input-hint"
            data-cy="original-car-hint">
            {{ ("originally" | i18n) || "Ursprünglich" | titlecase }}:
            <span
              *ngIf="
                (deviatingCarValue$ | async) ===
                carLicenseEnum.LICENSE_AVAILABLE
              ">
              {{ ("carLicenseEnum.0" | i18n) || "Fahrausweis" | titlecase }}
            </span>
            <span
              *ngIf="
                (deviatingCarValue$ | async) ===
                carLicenseEnum.CAR_AND_LICENSE_AVAILABLE
              ">
              {{
                ("carLicenseEnum.1" | i18n) || "Auto und Fahrausweis"
                  | titlecase
              }}
            </span>
            <span
              *ngIf="
                (deviatingCarValue$ | async) === undefined ||
                (deviatingCarValue$ | async) === null
              ">
              {{ ("empty" | i18n) || "Leer" | titlecase }}
            </span>
          </div>
        </ng-template>
      </app-mobility-select>
      <app-language-select
        *ngIf="!loggedInCustomer?.hiddenFields?.employmentLanguage"
        [formControl]="languageControl"
        class="light-form-field">
        <ng-template
          #hint
          *ngIf="hasDeviatingLanguage$ | async">
          <div
            class="input-hint"
            data-cy="original-language-hint">
            {{ ("originally" | i18n) || "Ursprünglich" | titlecase }}:
            <span *ngIf="(deviatingLanguageValue$ | async) != null">
              {{ "languageEnum." + (deviatingLanguageValue$ | async) | i18n }}
            </span>
            <span
              *ngIf="
                (deviatingLanguageValue$ | async) === undefined ||
                (deviatingLanguageValue$ | async) === null
              ">
              {{ ("empty" | i18n) || "nicht definiert" | titlecase }}
            </span>
          </div>
        </ng-template>
      </app-language-select>
    </div>
  </div>
  <div class="card-box">
    <h1 class="card-title">
      {{ ("employees" | i18n) || "Mitarbeiter" | titlecase }}
    </h1>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="light-form-field">
          <mat-label>{{
            ("requiredEmployees" | i18n) || "Benötigte Mitarbeiter"
          }}</mat-label>
          <input
            matInput
            [formControl]="requiredUsersControl"
            name="requiredEmployees"
            type="number"
            [min]="1"
            max="1000"
            data-cy="required-employees-input" />
        </mat-form-field>
      </div>
    </div>
    <ng-container *ngIf="employment?.invitees?.length">
      <h2 class="card-sub-title">
        {{
          ("requestedEmployees" | i18n) || "Angefragte Mitarbeiter" | titlecase
        }}
      </h2>
      <div
        class="light-table requested-users-table"
        data-cy="employment-edit-invitees">
        <div class="light-table-header">
          <div>{{ ("name" | i18n) || "Name" | titlecase }}</div>
          <div>{{ ("match" | i18n) || "Match" | titlecase }}</div>
        </div>
        <ng-container
          *ngFor="
            let invitee of visibleInvitees$ | async;
            trackBy: trackByInviteeId
          ">
          <app-employment-invitee-list-item
            *ngIf="
              (renderedInviteeIds$ | async)?.has(invitee.id);
              else employmentInviteeSkeleton
            "
            class="light-table-list-item light-table-interactable-item"
            [employment]="employment"
            [employmentCustomer]="(customerOfEmployment$ | async) || undefined"
            [loggedInCustomer]="loggedInCustomer"
            [isDisabled]="inviteeActionsDisabled"
            [isClosed]="employment?.status === EmploymentStatusEnum.CLOSED"
            [invitee]="invitee"
            [fromDate]="startDateControl.value || undefined"
            [toDate]="
              endDateControl.value || undefined
            "></app-employment-invitee-list-item>
          <ng-template #employmentInviteeSkeleton>
            <div class="invitee-skeleton"></div>
          </ng-template>
        </ng-container>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        !formDisabled && !restrictEdit && (hasRequiredFieldsForQuery$ | async)
      ">
      <h2 class="card-sub-title">
        {{
          ("availableEmployees" | i18n) || "Verfügbare Mitarbeiter" | titlecase
        }}
        ({{ (possibleUsers$ | async)?.length }})
      </h2>
      <div
        class="light-table available-users-table"
        data-cy="employment-edit-possible-users"
        *ngIf="startDateControl.value && endDateControl.value">
        <ng-container
          *ngIf="possibleUsersWithMatch$ | async as possibleUsersWithMatch">
          <div class="light-table-header">
            <div class="d-flex">
              <mat-checkbox
                class="select-all"
                [formControl]="selectAllUsersControl"
                (change)="toggleSelectAllUsers(possibleUsersWithMatch)"
                data-cy="select-all-checkbox"></mat-checkbox>
              <div>{{ ("name" | i18n) || "Name" | titlecase }}</div>
            </div>
            <div>{{ ("match" | i18n) || "Match" | titlecase }}</div>
          </div>
          <app-employment-user-list-item
            *ngFor="let user of possibleUsersWithMatch$ | async"
            class="light-table-list-item light-table-interactable-item"
            [inviteCheckboxEnabled]="!!selectedInviteesMap.get(user._id)"
            (inviteCheckboxChange)="
              toggleInvitedUser(user, possibleUsersWithMatch)
            "
            [loggedInUser]="loggedInUser"
            [loggedInCustomer]="loggedInCustomer"
            [employmentCustomer]="(customerOfEmployment$ | async) || undefined"
            [user]="user"
            [fromDate]="startDateControl.value || undefined"
            [toDate]="endDateControl.value || undefined"
            [workload]="workloadControl.value"
            [departmentId]="employment?.department?.id ?? ''">
          </app-employment-user-list-item>
        </ng-container>
      </div>
      <div
        class="d-flex flex-column align-end unknown-availabilities-row gap-8">
        <mat-slide-toggle
          [formControl]="includeUndecidedAvailabilityControl"
          name="toggleUndecided"
          labelPosition="before"
          class="include-undecided"
          data-cy="include-undecided-checkbox">
          {{ ("includeUndecided" | i18n) || "Include unknown availability" }}
        </mat-slide-toggle>
        <mat-slide-toggle
          *ngIf="loggedInCustomer?.allowIgnoreUserPreferenceDepartmentBlacklist"
          [formControl]="ignoreUserPreferenceDepartmentBlacklistControl"
          labelPosition="before"
          name="toggleIgnoreUserPreferenceDepartmentBlacklist"
          data-cy="ignore-user-preference-department-blacklist-checkbox">
          {{
            ("allowIgnoreUserPreferenceDepartmentBlacklist" | i18n) ||
              "Abteilungspräferenz der Mitarbeiter Ignorieren"
          }}
        </mat-slide-toggle>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="transfers$ | async as transfers">
    <div
      class="card-box"
      *ngIf="transfers?.length">
      <div class="card-title-row">
        <h1 class="card-title">
          {{ ("transfer" | i18n) || "transfer" | titlecase }}
        </h1>

        <ng-container
          *ngIf="
            (employment?.customer?.id == loggedInUser?.customerId ||
              isNewEmployment) &&
            !restrictEdit &&
            !formDisabled
          ">
          <button
            *ngIf="!isNewEmployment && !transferredAll"
            mat-button
            type="button"
            class="transfer-button"
            (click)="manualTransferAll()">
            <mat-icon svgIcon="board-mission-transfer-arrow"></mat-icon>
            {{ ("transferToAll" | i18n) || "An alle transferieren" }}
          </button>
          <mat-checkbox
            *ngIf="isNewEmployment"
            data-cy="direct-transfer"
            [checked]="transferAll"
            (change)="directTransferAllCheckboxChange()"
            class="direct-transfer-all-checkbox">
          </mat-checkbox>
        </ng-container>
      </div>
      <div class="transfers-list">
        <ng-container *ngFor="let transfer of transfers; let i = index">
          <div
            *ngIf="
              isNewEmployment ||
              employment?.customer?.id === loggedInUser?.customerId ||
              transfer.targetCustomer.id === loggedInUser?.customerId
            "
            class="transfers-list-item"
            [attr.data-cy]="
              !transfer.transferredAt
                ? 'transferable-transfer'
                : 'transferred-transfer'
            ">
            <ng-container *ngIf="!transfer.transferredAt">
              <div class="transfers-list-item-header">
                <div class="transfer-target-customer">
                  <mat-icon svgIcon="person-user-arrow-transfer"></mat-icon>
                  <h3 data-cy="transfer-display-name">
                    {{ transfer.targetCustomer.displayName }}
                  </h3>

                  <ng-container *ngIf="transfer.availabilityInfosForAgents">
                    <mat-icon
                      data-cy="availabilityInfosForAgents-icon"
                      class="mx-2 mat-info-icon-pointer"
                      svgIcon="information-outline"
                      (click)="
                        openAgentDialog(
                          transfer.availabilityInfosForAgents,
                          transfer.targetCustomer.displayName
                        )
                      "></mat-icon>
                  </ng-container>
                </div>
                <div class="transfer-transfer-action">
                  <div
                    *ngIf="
                      (transfer.auto || transfer.directTransfer) &&
                      transfer.transferAt &&
                      !restrictEdit &&
                      !formDisabled &&
                      (!transfer.conditionallyBlocked ||
                        transfer.conditionallyBlockedUntil)
                    "
                    class="transfer-auto">
                    <mat-icon
                      svgIcon="board-mission-transfer-auto-star"></mat-icon>
                    <span
                      *ngIf="
                        !transfer.directTransfer &&
                        transfer.transferAt > startDateControl.value
                      ">
                      {{
                        "automaticallyAt"
                          | i18n
                            : {
                                date:
                                  transfer.transferAt
                                  | displayDate: "dd.MM.yyyy",
                                distance: transfer.transferAt | formatDistance
                              }
                      }}
                    </span>
                    <span
                      *ngIf="
                        transfer.directTransfer ||
                        transfer.transferAt <= startDateControl.value
                      ">
                      {{
                        ("automaticallyImmediately" | i18n) ||
                          "automatisch sofort"
                      }}
                    </span>
                  </div>
                  <button
                    *ngIf="
                      employment?.customer?.id === loggedInUser?.customerId &&
                      !isNewEmployment &&
                      !restrictEdit &&
                      !formDisabled &&
                      !transfer.conditionallyBlocked
                    "
                    mat-button
                    type="button"
                    class="transfer-button"
                    data-cy="transfer-button"
                    (click)="transferEmployment(transfer)">
                    <mat-icon svgIcon="board-mission-transfer-arrow"></mat-icon>
                    {{ ("transferNow" | i18n) || "Jetzt transferieren" }}
                  </button>
                  <mat-checkbox
                    *ngIf="isNewEmployment && !transfer.conditionallyBlocked"
                    class="new-checkbox-color"
                    data-cy="direct-transfer"
                    [checked]="transfer.directTransfer || false"
                    [labelPosition]="'before'"
                    (change)="directTransferCheckboxChange(transfer)">
                    {{ ("directTransfer" | i18n) || "Direkt Transferieren" }}
                  </mat-checkbox>
                </div>
              </div>
              <div class="transfers-list-item-body">
                <div
                  *ngIf="
                    !transfer.directTransfer &&
                    !restrictEdit &&
                    !formDisabled &&
                    (!transfer.conditionallyBlocked ||
                      transfer.conditionallyBlockedUntil)
                  ">
                  <mat-checkbox
                    [checked]="transfer.auto || false"
                    class="new-checkbox-color"
                    data-cy="auto-transfer"
                    (change)="transferAutoCheckboxChange(transfer)">
                    <span class="transfer-checkbox">
                      <mat-icon
                        svgIcon="board-mission-transfer-auto-star"></mat-icon>
                      {{
                        ("transferAutomatically" | i18n) ||
                          "Automatisch transferieren"
                      }}
                    </span>
                  </mat-checkbox>
                </div>
                <div
                  *ngIf="
                    !transfer.forceDirectAccept &&
                    !transfer.hideDirectAccept &&
                    !restrictEdit &&
                    !formDisabled &&
                    (!transfer.conditionallyBlocked ||
                      transfer.conditionallyBlockedUntil)
                  ">
                  <mat-checkbox
                    [checked]="!transfer.preventDirectAccept"
                    class="new-checkbox-color"
                    data-cy="allow-direct-accept"
                    (change)="
                      transferPreventDirectAcceptCheckboxChange(transfer)
                    ">
                    <span class="transfer-checkbox">
                      {{
                        ("allowDirectAccept" | i18n) || "Direktbuchen erlauben"
                      }}
                    </span>
                  </mat-checkbox>
                  <br />
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="transfer.transferredAt">
              <div class="transfers-list-item-header">
                <div class="transfer-target-customer">
                  <mat-icon svgIcon="person-user-arrow-transfer"></mat-icon>
                  <h3
                    data-cy="transfer-display-name"
                    *ngIf="
                      loggedInUser?.customerId === transfer.targetCustomer.id
                    ">
                    {{ employment?.customer?.displayName }}
                  </h3>
                  <h3
                    data-cy="transfer-display-name"
                    *ngIf="
                      loggedInUser?.customerId == employment?.customer?.id
                    ">
                    {{ transfer.targetCustomer.displayName }}

                    <ng-container *ngIf="transfer.availabilityInfosForAgents">
                      <mat-icon
                        class="mx-2 mat-info-icon-pointer"
                        svgIcon="information-outline"
                        (click)="
                          openAgentDialog(
                            transfer.availabilityInfosForAgents,
                            transfer.targetCustomer.displayName
                          )
                        "></mat-icon>
                    </ng-container>
                  </h3>
                </div>
                <div class="transfer-transferred-at">
                  <mat-icon svgIcon="board-mission-transfer-arrow"></mat-icon>
                  <div>
                    {{
                      "transferredAt"
                        | i18n
                          : {
                              date:
                                transfer.transferredAt
                                | displayDate: "dd.MM.yyyy",
                              distance: transfer.transferredAt | formatDistance
                            }
                    }}
                    <span *ngIf="transfer.transferredBy?.firstName">
                      <br />
                      {{ ("by" | i18n) || "von" }}

                      {{
                        transfer.transferredBy?.firstName +
                          " " +
                          transfer.transferredBy?.lastName
                      }}
                    </span>
                  </div>
                </div>
                <div
                  *ngIf="transfer.declinedAt"
                  class="transfer-declined-at">
                  <mat-icon
                    svgIcon="board-mission-transfer-decline-rejected"></mat-icon>
                  <div>
                    {{
                      "declinedAt"
                        | i18n
                          : {
                              date:
                                transfer.declinedAt | displayDate: "dd.MM.yyyy",
                              distance: transfer.declinedAt | formatDistance
                            }
                    }}
                    <span *ngIf="transfer.declinedBy?.firstName">
                      <br />
                      {{ ("by" | i18n) || "von" }}
                      {{
                        transfer.declinedBy?.firstName +
                          " " +
                          transfer.declinedBy?.lastName
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <div
    class="card-box flex justify-end"
    *ngIf="canDecline">
    <button
      class="outline-pill-button icon-left text-error"
      type="button"
      data-cy="decline-employment"
      (click)="declineTransfer()">
      <mat-icon svgIcon="close"></mat-icon>
      {{ ("declineEmployment" | i18n) || "Einsatz ablehnen" | titlecase }}
    </button>
  </div>
  <div
    class="card-box flex justify-end"
    *ngIf="canCancel$ | async">
    <button
      mat-button
      color="warn"
      type="button"
      data-cy="cancel-employment"
      (click)="cancelEmployment()">
      {{ ("cancelSomething" | i18n) || "Stornieren" | uppercase }}
    </button>
  </div>
</ng-container>

<div class="floating-actions-bar">
  <button
    class="secondary-pill-button icon-left big-fab"
    (click)="historyBack()"
    type="button"
    [class.invalid]="!form.valid"
    data-cy="return-employment-button">
    <mat-icon svgIcon="arrow-left"></mat-icon>
    {{ ("back" | i18n) || "zurück" | titlecase }}
  </button>
  <button
    *ngIf="hasUnsavedChanges()"
    class="primary-pill-button icon-left big-fab"
    type="button"
    (click)="saveEmployment()"
    [class.invalid]="!form.valid"
    data-cy="save-employment-button">
    <ng-container *ngIf="form.dirty">
      <ng-container *ngIf="isNewEmployment">
        <ng-container *ngIf="selectedInvitees.length">
          <mat-icon svgIcon="send"></mat-icon
          >{{
            ("inviteAndCreate" | i18n) || "Einladen und erstellen" | titlecase
          }}
        </ng-container>
        <ng-container *ngIf="!selectedInvitees.length">
          <mat-icon svgIcon="send"></mat-icon
          >{{ ("create" | i18n) || "erstellen" | titlecase }}
        </ng-container></ng-container
      >
      <ng-container *ngIf="!isNewEmployment">
        <ng-container *ngIf="selectedInvitees.length">
          <mat-icon svgIcon="send"></mat-icon
          >{{
            ("inviteAndSave" | i18n) || "Einladen und speichern" | titlecase
          }}</ng-container
        >
        <ng-container *ngIf="!selectedInvitees.length">
          <mat-icon svgIcon="send"></mat-icon
          >{{ ("save" | i18n) || "speichern" | titlecase }}</ng-container
        >
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!form.dirty">
      <mat-icon svgIcon="send"></mat-icon
      >{{ ("invite" | i18n) || "Einladen" | titlecase }}
    </ng-container>
  </button>
</div>
